<ion-card>
    <ion-fab vertical="center" horizontal="end"  *ngIf="document.customer.name">
        <ion-row class="ion-no-margin ion-no-padding">
            <ion-col class="ion-no-margin ion-no-padding" *ngIf="document.documentType === 7">
                <ion-fab-button color="light" (click)="clearCustomer()" size="small">
                    <ion-icon name="close"></ion-icon>
                </ion-fab-button>
            </ion-col>
            <ion-col class="ion-no-margin ion-no-padding">
                <ion-fab-button *ngIf="readonly === false" (click)="openModal(1)" size="small" color="light">
                    <ion-icon name="search"></ion-icon>
                </ion-fab-button>
            </ion-col>
        </ion-row>
    </ion-fab>
    <ion-card-content *ngIf="!document.customer.name" (click)="openModal(1)">
        <ion-label>Select Customer...</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="document.customer.name">
        <ion-label>
            <h4><strong>{{ document.customer.name }}</strong></h4>
            <p style="color: #1aacc3">Location : {{ getDepotName( document.customer.location )  }}</p>
            <p>{{ document.customer.cod }}</p>
            <p>{{ document.customer.add1 }}</p>
            <p>{{ document.customer.add2 }}</p>
            <p>{{ document.customer.add3 }}</p>
            <p>{{ document.customer.add4 }}</p>
        </ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="document.customer.name && (document.documentType === docTypes.CONTRACT)">
        <ion-button expand="full" (click)="openModal(2)" shape="round" color="light">
            Load Existing Order
        </ion-button>
    </ion-card-content>
</ion-card>
